module.exports = __webpack_public_path__ + "img/bp_giftbg_0004.1169019c.png";